import React, { Component } from 'react';
import {
    Container,
    Grid,
    Box,
    Typography,
    Breadcrumbs,
    Card,
    CardContent,
    Button,
    IconButton,
    CircularProgress,
    Link as MuiLink,
    Paper,
    Divider,
    Chip,
    Avatar
} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ForumIcon from '@mui/icons-material/Forum';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { singleForumPost, remove, like, unlike } from './apiForum';
import { Link, Redirect } from 'react-router-dom';
import { isAuthenticated } from '../auth';
import Comment from './Comment';
import { createDownloadLink } from '../file/apiFiles';
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Footer from '../core/Footer';

class SingleForumPost extends Component {
    state = {
        forumpost: '',
        redirectToHome: false,
        redirectToSignin: false,
        like: false,
        likes: 0,
        comments: [],
        fileLink: '',
        fileName: '',
        editorState: EditorState.createEmpty()
    };

    checkLike = likes => {
        const userId = isAuthenticated() && isAuthenticated().userId;
        let match = likes.indexOf(userId) !== -1;
        return match;
    };

    componentDidMount = () => {
        const forumpostId = this.props.match.params.forumpostId;
        singleForumPost(forumpostId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    forumpost: data,
                    likes: data.likes.length,
                    like: this.checkLike(data.likes),
                    comments: data.comments,
                    editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(data.body)))
                });
                if (data.filetoLink !== undefined) {
                    this.setState({ ...this.state, fileName: data.filetoLink.fileName });
                    const fileInfo = {
                        fileName: data.filetoLink.fileName,
                        awsVersion: data.filetoLink.awsVersion
                    }
                    createDownloadLink(isAuthenticated().token, fileInfo).then(data => {
                        if (data.error) {
                            console.log(data.error);
                        } else {
                            //console.log(data);
                            //return data
                            this.setState({ ...this.state, fileLink: data });
                        }
                    });
                }
            }
        });
        // ReactGA.initialize('UA-331790-15')
        // ReactGA.pageview('/forumpost/' + forumpostId);
    };

    updateComments = comments => {
        this.setState({ comments });
    };

    likeToggle = () => {
        if (!isAuthenticated()) {
            this.setState({ redirectToSignin: true });
            return false;
        }
        let callApi = this.state.like ? unlike : like;
        const userId = isAuthenticated().userId;
        const forumpostId = this.state.forumpost._id;
        const token = isAuthenticated().token;

        callApi(userId, token, forumpostId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    like: !this.state.like,
                    likes: data.likes.length
                });
            }
        });
    };

    deleteForumPost = () => {
        const forumpostId = this.props.match.params.forumpostId;
        const token = isAuthenticated().token;
        remove(forumpostId, token).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ redirectToHome: true });
            }
        });
    };

    deleteConfirmed = () => {
        let answer = window.confirm('Are you sure you want to delete your forum post?');
        if (answer) {
            this.deleteForumPost();
        }
    };

    renderPost = forumpost => {
        const posterId = forumpost.forumpostedBy ? `/user/${forumpost.forumpostedBy._id}` : '';
        const posterName = forumpost.forumpostedBy ? forumpost.forumpostedBy.name : 'Unknown';
        const posterLastName = forumpost.forumpostedBy ? (forumpost.forumpostedBy.lastName || '') : '';

        const { like, likes } = this.state;

        // Generate initials safely
        const getInitials = () => {
            const firstInitial = posterName && posterName.length > 0 ? posterName.charAt(0) : 'U';
            const lastInitial = posterLastName && posterLastName.length > 0 ? posterLastName.charAt(0) : '';
            return firstInitial + lastInitial;
        };

        return (
            <Card elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                {/* Post Header with Author Info */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                        <Avatar
                            sx={{
                                width: 56,
                                height: 56,
                                backgroundColor: '#FF6600',
                                fontSize: '1.5rem',
                                fontWeight: 600
                            }}
                        >
                            {getInitials()}
                        </Avatar>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                <MuiLink component={Link} to={`${posterId}`} sx={{ color: 'white', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
                                    {posterName} {posterLastName}
                                </MuiLink>
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                <CalendarTodayIcon sx={{ fontSize: 16 }} />
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                    {new Date(forumpost.created).toDateString()}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <CardContent sx={{ p: 3 }}>
                    {/* Like Button */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <Button
                            variant={like ? "contained" : "outlined"}
                            color={like ? "success" : "primary"}
                            startIcon={<ThumbUpIcon />}
                            onClick={this.likeToggle}
                            sx={{
                                borderRadius: 999,
                                textTransform: 'none',
                                fontWeight: 600,
                                ...(like && {
                                    backgroundColor: '#4caf50',
                                    '&:hover': { backgroundColor: '#388e3c' }
                                }),
                                ...(!like && {
                                    borderColor: '#003E7E',
                                    color: '#003E7E',
                                    '&:hover': { borderColor: '#003E7E', backgroundColor: 'rgba(0, 62, 126, 0.1)' }
                                })
                            }}
                        >
                            {likes} {likes === 1 ? 'Like' : 'Likes'}
                        </Button>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    {/* Post Content */}
                    <Box sx={{ mb: 3, '& .public-DraftEditor-content': { minHeight: '100px' } }}>
                        <Editor
                            toolbarHidden={true}
                            editorState={this.state.editorState}
                            readOnly={true}
                            wrapperClassName="demo-wrapper"
                            editorClassName="editer-content"
                        />
                    </Box>

                    {/* File Attachment */}
                    {this.state.fileName && (
                        <Paper
                            elevation={1}
                            sx={{
                                p: 2,
                                mb: 3,
                                backgroundColor: 'rgba(0, 62, 126, 0.05)',
                                borderLeft: '4px solid #FF6600'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <AttachFileIcon sx={{ color: '#FF6600' }} />
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                    Attached File:
                                </Typography>
                                <MuiLink
                                    href={`${this.state.fileLink}`}
                                    title="Click to Download"
                                    sx={{
                                        color: '#FF6600',
                                        fontWeight: 600,
                                        '&:hover': { color: '#e55a00' }
                                    }}
                                >
                                    {this.state.fileName}
                                </MuiLink>
                            </Box>
                        </Paper>
                    )}

                    <Divider sx={{ mb: 3 }} />

                    {/* Action Buttons */}
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Button
                            component={Link}
                            to={`/usershome`}
                            variant="outlined"
                            sx={{
                                borderColor: '#003E7E',
                                color: '#003E7E',
                                '&:hover': {
                                    borderColor: '#003E7E',
                                    backgroundColor: 'rgba(0, 62, 126, 0.1)'
                                }
                            }}
                        >
                            Back to Home
                        </Button>

                        {isAuthenticated().user && isAuthenticated().userId === forumpost.forumpostedBy._id && (
                            <>
                                <Button
                                    component={Link}
                                    to={`/forumpost/edit/${forumpost._id}`}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#FF6600',
                                        '&:hover': { backgroundColor: '#e55a00' }
                                    }}
                                >
                                    Edit Post
                                </Button>
                                <Button
                                    onClick={this.deleteConfirmed}
                                    variant="outlined"
                                    color="error"
                                >
                                    Delete Post
                                </Button>
                            </>
                        )}
                    </Box>

                    {/* Admin Controls */}
                    {isAuthenticated().user && isAuthenticated().role === 'admin' && (
                        <Paper
                            elevation={2}
                            sx={{
                                mt: 3,
                                p: 2,
                                backgroundColor: 'rgba(244, 67, 54, 0.05)',
                                borderLeft: '4px solid #f44336'
                            }}
                        >
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, color: '#f44336' }}>
                                Admin Controls
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                You can edit or delete this post as an administrator
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                    component={Link}
                                    to={`/forumpost/edit/${forumpost._id}`}
                                    variant="contained"
                                    color="warning"
                                    size="small"
                                >
                                    Edit Post
                                </Button>
                                <Button
                                    onClick={this.deleteConfirmed}
                                    variant="contained"
                                    color="error"
                                    size="small"
                                >
                                    Delete Post
                                </Button>
                            </Box>
                        </Paper>
                    )}
                </CardContent>
            </Card>
        );
    };

    render() {
        const { forumpost, redirectToHome, redirectToSignin, comments } = this.state;

        if (redirectToHome) {
            return <Redirect to={`/usershome`} />;
        } else if (redirectToSignin) {
            return <Redirect to={`/signin`} />;
        }

        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 5, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            sx={{
                                mb: 3,
                                '& .MuiBreadcrumbs-separator, & a, & p': { color: 'rgba(255, 255, 255, 0.7)' }
                            }}
                        >
                            <MuiLink component={Link} to="/usershome" underline="hover">
                                Home
                            </MuiLink>
                            <MuiLink component={Link} to="/grouplist" underline="hover">
                                Committees
                            </MuiLink>
                            <Typography sx={{ color: 'white !important' }}>Forum Post</Typography>
                        </Breadcrumbs>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <ForumIcon sx={{ fontSize: 56 }} />
                            <Box>
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 600 }}>
                                    {forumpost ? forumpost.title : 'Loading...'}
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ mb: 6 }}>
                    {!forumpost ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                            <Box sx={{ textAlign: 'center' }}>
                                <CircularProgress size={60} sx={{ color: '#003E7E', mb: 2 }} />
                                <Typography variant="h5" sx={{ color: '#003E7E' }}>Loading post...</Typography>
                            </Box>
                        </Box>
                    ) : (
                        <>
                        <Grid container spacing={12}>
                            <Grid item xs={12} lg={12}>
                                {this.renderPost(forumpost)}
                            </Grid>                            
                        </Grid>
                        <br/>
                        <Grid item xs={12} lg={12}>
                                <Card elevation={3} sx={{ borderRadius: 3, position: 'sticky', top: 20 }}>
                                    <Box sx={{ backgroundColor: '#003E7E', color: 'white', p: 2 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                            Comments ({comments.length})
                                        </Typography>
                                    </Box>
                                    <CardContent sx={{ p: 3 }}>
                                        <Comment
                                            postId={forumpost._id}
                                            comments={comments.reverse()}
                                            updateComments={this.updateComments}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                            </>
                    )}
                </Container>

                <Footer />
            </>
        );
    }
}

export default SingleForumPost;